var exports = {
  "kL": "xaf9ae18d--bbdd23--container",
  "Sl": "xaf9ae18d--bbdd23--image",
  "Qs": "xaf9ae18d--bbdd23--content",
  "hX": "xaf9ae18d--bbdd23--inner-content",
  "qr": "xaf9ae18d--bbdd23--footer",
  "DD": "xaf9ae18d--bbdd23--title",
};

module.exports = exports;
